import { render, staticRenderFns } from "./free-promo-linked-gift-cards-cart-item.vue?vue&type=template&id=398bdb52&lang=pug"
import script from "./free-promo-linked-gift-cards-cart-item.vue?vue&type=script&lang=js"
export * from "./free-promo-linked-gift-cards-cart-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports